/**
 * Key origin: https://console.cloud.google.com/apis/credentials?project=wings-poe
 */
import { getSecret } from '@/composables/useSecrets'

export function initGoogleMapsKey() {
  const key = getSecret('google_maps_api_key') ?? import.meta.env.VITE_GOOGLE_MAPS_API_KEY

  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&language=en&libraries=places&callback=initMap&loading=async`
  document.head.appendChild(script)
}
